import { createApiHooks } from '@apis/next/common';
import { Overview } from '@models/next/Overview';
import { ServiceName } from '@models/next/RoutePlan';

export const overviewApis = createApiHooks('/dashboard/overview', [
  {
    method: 'get',
    path: '/',
    parameters: [
      {
        type: 'Query',
        name: 'service',
        description: 'Service name',
        schema: ServiceName.array(),
      },
    ],
    response: Overview,
  },
]);
